<template>
  <div>
    <v-card flat>
      <v-data-table
        :headers="headers"
        :items="filteredCategories"
        :items-per-page="10"
        class="elevation-0 custom-data-table"
        :no-data-text="noDataText"
        :height="tableHeight"
        fixed-header
        :loading="tableLoading"
        density="compact"
      >
        <template v-slot:top>
          <div class="d-flex justify-space-between align-center pa-4">
            <span class="text-h5">Category</span>
            <div class="d-flex align-center">
              <v-text-field
                v-model="search"
                prepend-inner-icon="mdi-magnify"
                label="Search"
                single-line
                hide-details
                variant="outlined"
                density="compact"
                style="width: 350px; margin-right: 16px"
              ></v-text-field>
              <v-btn
                color="primary"
                prepend-icon="mdi-plus"
                @click="openCreateDialog"
              >
                Create Category
              </v-btn>
            </div>
          </div>
        </template>

        <template v-slot:[`item.actions`]="{ item }">
          <v-btn
            icon
            size="small"
            variant="text"
            color="primary"
            @click.stop="editCategory(item)"
          >
            <v-icon>mdi-pencil</v-icon>
          </v-btn>
          <v-btn
            icon
            size="small"
            variant="text"
            color="error"
            @click.stop="deleteCategory(item)"
          >
            <v-icon>mdi-delete</v-icon>
          </v-btn>
        </template>
      </v-data-table>
    </v-card>

    <!-- Create Category Dialog -->
    <CreateCategoryDialog
      v-model="showCreateDialog"
      @created="handleCategoryCreated"
    />

    <!-- Edit Category Dialog -->
    <EditCategoryDialog
      v-model="showEditDialog"
      :category="selectedCategory"
      @updated="handleCategoryUpdated"
    />

    <!-- Delete Category Dialog -->
    <DeleteCategoryDialog
      v-model="showDeleteDialog"
      :category="selectedCategory"
      @deleted="handleCategoryDeleted"
    />
  </div>
</template>

<script>
import CreateCategoryDialog from "../../components/Category/Dailogs/CreateCategoryDialog.vue";
import EditCategoryDialog from "../../components/Category/Dailogs/EditCategoryDialog.vue";
import DeleteCategoryDialog from "../../components/Category/Dailogs/DeleteCategoryDialog.vue";
import GetCategories from "@/mixins/Category/GetCategories";

export default {
  name: "CategoryView",
  mixins: [GetCategories],
  components: {
    CreateCategoryDialog,
    EditCategoryDialog,
    DeleteCategoryDialog,
  },
  data() {
    return {
      showCreateDialog: false,
      showEditDialog: false,
      showDeleteDialog: false,
      tableLoading: false,
      selectedCategory: null,
      selectedIndex: -1,
      categories: [],
      search: "",
      windowHeight: window.innerHeight,
      headers: [
        { title: "Category Name", key: "category_name", sortable: true },
        { title: "Actions", key: "actions", sortable: false, align: "center" },
      ],
    };
  },
  computed: {
    noDataText() {
      return "No categories found. Click 'Create Category' to add one.";
    },
    tableHeight() {
      return this.windowHeight - 250;
    },
    filteredCategories() {
      if (!this.search) {
        return this.categories;
      }

      const searchTerm = this.search.toLowerCase().trim();
      return this.categories.filter((cat) => {
        return (
          cat.category_name &&
          cat.category_name.toLowerCase().includes(searchTerm)
        );
      });
    },
  },
  async mounted() {
    this.updateWindowHeight();
    window.addEventListener("resize", this.updateWindowHeight);
    this.tableLoading = true;
    try {
      await this.fetchCategories();
      this.categories = this.categoriesList;
    } catch (error) {
      console.error("Error loading categories:", error);
    } finally {
      this.tableLoading = false;
    }
  },
  beforeUnmount() {
    window.removeEventListener("resize", this.updateWindowHeight);
  },
  methods: {
    updateWindowHeight() {
      this.windowHeight = window.innerHeight;
    },
    openCreateDialog() {
      this.showCreateDialog = true;
    },
    async handleCategoryCreated() {
      // Refetch the category list from API
      this.tableLoading = true;
      try {
        await this.fetchCategories();
        this.categories = this.categoriesList;
      } catch (error) {
        console.error("Error loading categories:", error);
      } finally {
        this.tableLoading = false;
      }
    },
    editCategory(cat) {
      this.selectedCategory = { ...cat };
      // Find the actual index in the original categories array
      this.selectedIndex = this.categories.findIndex(
        (c) => c.category_name === cat.category_name
      );
      this.showEditDialog = true;
    },
    async handleCategoryUpdated() {
      // Refetch the category list from API
      this.tableLoading = true;
      try {
        await this.fetchCategories();
        this.categories = this.categoriesList;
      } catch (error) {
        console.error("Error loading categories:", error);
      } finally {
        this.tableLoading = false;
      }
      this.selectedIndex = -1;
      this.selectedCategory = null;
    },
    deleteCategory(cat) {
      this.selectedCategory = { ...cat };
      // Find the actual index in the original categories array
      this.selectedIndex = this.categories.findIndex(
        (c) => c.category_name === cat.category_name
      );
      this.showDeleteDialog = true;
    },
    async handleCategoryDeleted() {
      // Refetch the category list from API
      this.tableLoading = true;
      try {
        await this.fetchCategories();
        this.categories = this.categoriesList;
      } catch (error) {
        console.error("Error loading categories:", error);
      } finally {
        this.tableLoading = false;
      }
      this.selectedIndex = -1;
      this.selectedCategory = null;
    },
  },
};
</script>

